import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { fetcher } from '../../client'
import { redeemCoupon } from '../../actions/coupons'

export function useRedeemCoupon(options = {}) {
  const { t } = useTranslation(['common']);
  return useMutation((payload) => fetcher(redeemCoupon(payload)), {
    ...options,
    onSuccess: (payload, variables) => {
      if (options.onSuccess) options.onSuccess(payload, variables)
      toast.success(t('successMessages.couponRedeemed'))
    },
    onError: (err) => {
      toast.error(t(`errors.${err.message}`), t('errorMessages.couponRedeemed'), {
          toastId: 'couponRedeemedError'
      })
    }
  });
}
